import React from 'react';
import { motion } from 'framer-motion';
import { Download, CreditCard, FileText } from 'lucide-react';
const deliverables = [{
  icon: Download,
  title: 'Instant PDF Download',
  desc: 'Access the full guide in seconds. No app, no waiting.',
  color: 'bg-sage/10 text-sage-dark'
}, {
  icon: CreditCard,
  title: '5 Emergency Calm Cards',
  desc: 'Pocket-sized rescue scripts for the hardest moments.',
  color: 'bg-terracotta/10 text-terracotta'
}, {
  icon: FileText,
  title: '1-Page Protocol Sheet',
  desc: 'Your entire reset plan on a single, scannable sheet.',
  color: 'bg-brown/10 text-brown'
}];
export function WhatYouGet() {
  return <section className="py-16 md:py-20 px-6 md:px-8 bg-cream" data-id="element-623">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto" data-id="element-624">
        <div className="text-center mb-10" data-id="element-625">
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold mb-3" data-id="element-626">
            What's Inside
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-brown" data-id="element-627">
            Everything you need. Nothing you don't.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5" data-id="element-628">
          {deliverables.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white p-7 rounded-2xl shadow-sm border border-brown/5 flex flex-col items-center text-center gap-4" data-id="element-629">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${item.color}`} data-id="element-630">
                <item.icon className="w-5 h-5" data-id="element-631" />
              </div>
              <div data-id="element-632">
                <h3 className="font-serif text-lg text-brown font-medium mb-1.5" data-id="element-633">
                  {item.title}
                </h3>
                <p className="text-sm text-brown-light leading-relaxed" data-id="element-634">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}